import { useEffect } from 'react';
import { useExit } from '@wix/cli-ui-kit';
import { useSiteConfig } from '../../../model.js';
import { useDevEnvironment } from '../DevEnvironment.js';
import { useUpdateDeploymentTopologyForSite } from '../../../hooks/useUpdateDeploymentTopology.js';

export function useSiteDeploymentTopologyUpdater() {
  const { baseUrl, devArmTag } = useDevEnvironment();
  const { siteId } = useSiteConfig();
  const updateTopology = useUpdateDeploymentTopologyForSite(siteId);
  const exit = useExit();

  useEffect(() => {
    updateTopology({
      armTag: devArmTag,
      siteUrl: baseUrl,
      environment: 'development',
    }).catch(exit);
  }, [devArmTag, baseUrl, updateTopology, exit]);
}
